"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.scss");
var classnames_1 = require("classnames");
var ProductTags = (function (_super) {
    __extends(ProductTags, _super);
    function ProductTags(props) {
        var _this = _super.call(this, props) || this;
        _this.onScroll = function () {
            var stickToTop = _this.props.stickToTop;
            var navToTop = _this.navWrapRef.getBoundingClientRect().top;
            var parentNode = _this.navWrapRef.parentNode;
            var parentToBottom = parentNode.getBoundingClientRect().bottom;
            if (_this.state.fixed) {
                if (_this.placeholderRef.getBoundingClientRect().top >= stickToTop ||
                    parentToBottom <= stickToTop) {
                    _this.setState({ fixed: false });
                }
                return;
            }
            if (navToTop <= stickToTop && parentToBottom > stickToTop) {
                _this.setState({ fixed: true });
            }
        };
        _this.loadElement = function (element) {
            if (element) {
                _this.navWrapRef = element;
                !_this.state.showExpand &&
                    element.offsetHeight > 60 &&
                    _this.setState({
                        showExpand: true
                    });
            }
        };
        _this.handelClickItem = function (item, index) { return function () {
            if (index !== _this.props.selectedIndex) {
                _this.props.onChange(item, index, _this.state.fixed);
            }
        }; };
        _this.getListStyle = function (active, colorTable) {
            return active
                ? { color: colorTable.textFocusColor, backgroundColor: colorTable.tagFocusBg }
                : { color: colorTable.textColor };
        };
        _this.state = {
            fixed: false,
            showExpand: false,
            expanded: (props.categories[0] && props.categories[0].tabExpand) || false
        };
        _this.navWrapRef = null;
        _this.placeholderRef = null;
        return _this;
    }
    ProductTags.prototype.componentDidMount = function () {
        var stick = this.props.stick;
        if (stick) {
            window.addEventListener("scroll", this.onScroll);
        }
    };
    ProductTags.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.onScroll);
    };
    ProductTags.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (this.navWrapRef && !prevState.showExpand) {
            this.navWrapRef.firstChild.offsetHeight > 60 &&
                this.setState({
                    showExpand: true
                });
        }
    };
    ProductTags.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, selectedIndex = _c.selectedIndex, categories = _c.categories, style = _c.style, className = _c.className, customUI = _c.customUI, stickToTop = _c.stickToTop;
        var _d = this.state, fixed = _d.fixed, showExpand = _d.showExpand, expanded = _d.expanded;
        return [
            React.createElement("div", { key: "placeholder", ref: function (element) { return (_this.placeholderRef = element); }, className: classnames_1.default(styles.categoryWrapper, (_a = {}, _a[styles.adorCategoryWrapper] = true, _a), className), style: __assign({
                    display: fixed ? "block" : "none",
                    marginTop: 12,
                    height: (this.navWrapRef && this.navWrapRef.offsetHeight) || null
                }, style) }),
            React.createElement("div", { key: "category", style: {
                    top: fixed ? stickToTop : "",
                    display: categories.length < 2 ? "none" : "",
                    backgroundColor: customUI ? customUI.bgColor : ""
                }, className: classnames_1.default(styles.categoryWrapper, (_b = {},
                    _b[styles.fixed] = fixed,
                    _b[styles.expanded] = expanded,
                    _b[styles.adorCategoryWrapper] = true,
                    _b)), ref: function (element) { return (_this.navWrapRef = element); } },
                React.createElement("ul", { key: "ul", className: classnames_1.default(styles.category, className), style: __assign({ paddingRight: showExpand ? 60 : "", backgroundColor: customUI ? customUI.bgColor : "" }, style) },
                    categories.map(function (item, index) { return (React.createElement("li", { key: index, onClick: _this.handelClickItem(item, index), style: (customUI &&
                            customUI.colorTable &&
                            _this.getListStyle(index === selectedIndex, customUI.colorTable)) ||
                            {} }, item.name)); }),
                    showExpand && (React.createElement("i", { onClick: function () { return _this.setState({ expanded: !expanded }); }, className: classnames_1.default(styles.controllerArrow, expanded ? styles.arrowUp : styles.arrowDown) }))))
        ];
    };
    ProductTags.defaultProps = {
        stick: true,
        stickToTop: 0
    };
    return ProductTags;
}(React.Component));
exports.default = ProductTags;
